import React from 'react';
import { Hero } from './components/Hero';
import { Antechamber } from './components/Antechamber';
import { ProblemSalon } from './components/ProblemSalon';
import { TheoremRoom } from './components/TheoremRoom';
import { Gallery } from './components/Gallery';
import { Observatory } from './components/Observatory';
import { Registry } from './components/Registry';
import { Footer } from './components/Footer';
export function App() {
  return <main className="bg-deep-green min-h-screen overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Antechamber data-id="element-2" />
      <ProblemSalon data-id="element-3" />
      <TheoremRoom data-id="element-4" />
      <Gallery data-id="element-5" />
      <Observatory data-id="element-6" />
      <Registry data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}